import React, { Dispatch, SetStateAction, useState } from 'react';
import Modal from '@/presentation/modal';
import { SButton } from '../styles/Button.styled';
import { faSearch } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import LabeledCheckbox from '../LabeledCheckbox';
import {
  SModalCheckboxContainter,
  SActionButtonsContainer,
  SLabel,
  SModalTitle,
  SLabelStandAlone,
} from './ModalGlobalSearch.styled';
import { SModalBodyContainer } from './ModalDialog.styled';
import { FormProvider, useForm } from 'react-hook-form';
import Input from '@/presentation/input/Input';
import useUpdateEffect from '@/hooks/useUpdateEffect';
import { useEffect } from 'react';
import { GetMessageSearchResultRequest } from '@/api/client';
import { fetchMessageSearchResults, setKeyWord, setMessageSearchBy, setUserSelection } from '@/features/messagesSlice';
import { useAppDispatch } from '@/hooks/customHooks';
import { useNavigate } from 'react-router-dom';
import { MessageCenterRoute } from '@/common/routes';

export interface IGlobalSearchForm {
  keyWord: string;
  location: boolean;
  messageTitle: boolean;
  messageId: boolean;
  graphicId: boolean;
  creatorUserId: boolean;
  approverUserId: boolean;
  requestorEmail: boolean;
  requestorFirstName: boolean;
  requestorLastName: boolean;
  requestorDepartment: boolean;
  messageText: boolean;
  selectivityFieldName: boolean;
  selectivityValue: boolean;
}
interface ModalGlobalSearch {
  show: boolean;
  setShow: Dispatch<SetStateAction<boolean>>;
  title: string;
  onClose: () => void;
}

export interface IDisableState {
  searchFields: boolean;
  standAloneSearchFields: boolean;
}

const ModalGlobalSearch: React.FC<ModalGlobalSearch> = ({ show, setShow, title, onClose }) => {
  const globalSearchFormDefaultValues: () => IGlobalSearchForm = () => {
    return {
      keyWord: '',
      location: false,
      messageTitle: false,
      messageId: false,
      graphicId: false,
      creatorUserId: false,
      approverUserId: false,
      requestorEmail: false,
      requestorFirstName: false,
      requestorLastName: false,
      requestorDepartment: false,
      messageText: false,
      selectivityFieldName: false,
      selectivityValue: false,
    };
  };

  const [isDisableSearch, setDisableSearch] = useState<boolean>(true);
  const [searchBy, setSearchBy] = useState<'searchFields' | 'standAloneSearchFields' | ''>('');
  const [disableLocation, setDisableLocation] = useState<boolean>(false);
  const [disableMessageTitle, setDisableMessageTitle] = useState<boolean>(false);
  const [disableMessageId, setDisableMessageId] = useState<boolean>(false);
  const [disableGraphicId, setDisableGraphicId] = useState<boolean>(false);
  const [disableCreatorUserId, setDisableCreatorUserId] = useState<boolean>(false);
  const [disableApproverUserId, setDisableApproverUserId] = useState<boolean>(false);
  const [disableRequestorEmail, setDisableRequestorEmail] = useState<boolean>(false);
  const [disableRequestorFirstName, setDisableRequestorFirstName] = useState<boolean>(false);
  const [disableRequestorLastName, setDisableRequestorLastName] = useState<boolean>(false);
  const [disableRequestorDepartment, setDisableRequestorDepartment] = useState<boolean>(false);
  const [disableMessageText, setDisableMessageText] = useState<boolean>(false);
  const [disableSelectivityFieldName, setDisableSelectivityFieldName] = useState<boolean>(false);
  const [disableSelectivityValue, setDisableSelectivityValue] = useState<boolean>(false);
  const [searchButtonToolTip, SetSearchButtonToolTip] = useState<string>('Search Value must be 3 or more characters.');
  const [searchKeyword, setSearchKeyword] = useState<string>('');
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const methods = useForm<IGlobalSearchForm>({
    defaultValues: globalSearchFormDefaultValues(),
    mode: 'onBlur',
  });

  const watchAllFields = methods.watch();

  useUpdateEffect(() => {
    handleSearchCriteriaCheckboxes();
    if (searchBy != '' && searchKeyword.trim().length >= 3) {
      setDisableSearch(false);
    } else {
      setDisableSearch(true);
    }
  }, [watchAllFields]);

  useEffect(() => {
    switch (searchBy) {
      case 'searchFields':
        setDisableMessageText(true);
        setDisableSelectivityFieldName(true);
        setDisableSelectivityValue(true);
        break;
      case 'standAloneSearchFields':
        DisableSearchFields(true);
        if (watchAllFields.messageText) {
          setDisableSelectivityFieldName(true);
          setDisableSelectivityValue(true);
        } else if (watchAllFields.selectivityFieldName) {
          setDisableMessageText(true);
          setDisableSelectivityValue(true);
        } else {
          setDisableMessageText(true);
          setDisableSelectivityFieldName(true);
        }
        break;
      default:
        DisableSearchFields(false);
        setDisableMessageText(false);
        setDisableSelectivityFieldName(false);
        setDisableSelectivityValue(false);
        break;
    }
  }, [searchBy]);

  const clearFormHandler = () => {
    methods.reset(globalSearchFormDefaultValues());
    onClose();
  };

  function handleSearchCriteriaCheckboxes() {
    if (watchAllFields.messageText || watchAllFields.selectivityFieldName || watchAllFields.selectivityValue) {
      setSearchBy('standAloneSearchFields');
    } else if (
      watchAllFields.approverUserId ||
      watchAllFields.creatorUserId ||
      watchAllFields.graphicId ||
      watchAllFields.location ||
      watchAllFields.messageId ||
      watchAllFields.messageTitle ||
      watchAllFields.requestorDepartment ||
      watchAllFields.requestorEmail ||
      watchAllFields.requestorFirstName ||
      watchAllFields.requestorLastName
    ) {
      setSearchBy('searchFields');
    } else {
      setSearchBy('');
    }
  }

  function DisableSearchFields(disableFlag: boolean) {
    setDisableLocation(disableFlag);
    setDisableMessageTitle(disableFlag);
    setDisableMessageId(disableFlag);
    setDisableGraphicId(disableFlag);
    setDisableCreatorUserId(disableFlag);
    setDisableApproverUserId(disableFlag);
    setDisableRequestorEmail(disableFlag);
    setDisableRequestorFirstName(disableFlag);
    setDisableRequestorLastName(disableFlag);
    setDisableRequestorDepartment(disableFlag);
  }

  const stripTrailingSpaces = (event: React.FocusEvent<HTMLInputElement>) => {
    const value = event.target.value;
    event.target.value = value.trim();
    setSearchKeyword(value.trim());
  };

  const validateKeyWord = (event: React.FocusEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setSearchKeyword(value);
    if (value.trim().length >= 3) {
      if (searchBy === '') {
        setDisableSearch(true);
        SetSearchButtonToolTip(
          'Search requires a minimum 3 character Search Value and at least 1 Search Field selected.',
        );
      } else {
        setDisableSearch(false);
        SetSearchButtonToolTip('Search');
      }
    } else {
      if (value.trim().length === 0) {
        event.target.value = '';
        setSearchKeyword('');
      }
      setDisableSearch(true);
      SetSearchButtonToolTip(
        'Search requires a minimum 3 character Search Value and at least 1 Search Field selected.',
      );
    }
  };

  const handleGlobalSearchData = () => {
    const data = methods.getValues() as IGlobalSearchForm;
    const request = {
      keyWord: data.keyWord,
      searchBy: searchBy === 'searchFields' ? '0' : '1',
      searchFields: {
        location: data.location,
        title: data.messageTitle,
        messageId: data.messageId,
        graphicId: data.graphicId,
        creatorUserId: data.creatorUserId,
        approverUserId: data.approverUserId,
        requestorEmail: data.requestorEmail,
        requestorFirstName: data.requestorFirstName,
        requestorLastName: data.requestorLastName,
        requestorDepartment: data.requestorDepartment,
      },
      standAloneSearchFields: {
        messageText: data.messageText,
        selectivityFieldName: data.selectivityFieldName,
        selectivityValue: data.selectivityValue,
      },
    } as unknown as GetMessageSearchResultRequest;
    dispatch(fetchMessageSearchResults(request));
    dispatch(setKeyWord(data.keyWord));
    dispatch(setMessageSearchBy(searchBy));
    dispatch(setUserSelection(getUserSelectedSearchCRiteria(data)));
    onClose();
    navigate(`/${(window as any).CSG_CONFIG.BASE_PATH}/${MessageCenterRoute}`);
  };

  const getUserSelectedSearchCRiteria = (data: Partial<IGlobalSearchForm>) => {
    const searchCriteria: string[] = [];
    if (searchBy == 'standAloneSearchFields') {
      if (data.messageText) searchCriteria.push('Message Text');
      if (data.selectivityFieldName) searchCriteria.push('Selectivity Field Name');
      if (data.selectivityValue) searchCriteria.push('Selectivity Value');
    } else {
      if (data.approverUserId) searchCriteria.push('Approver User ID');
      if (data.creatorUserId) searchCriteria.push('Creator User ID');
      if (data.graphicId) searchCriteria.push('Graphic ID');
      if (data.location) searchCriteria.push('Location Name');
      if (data.messageId) searchCriteria.push('Message ID');
      if (data.messageTitle) searchCriteria.push('Message Title');
      if (data.requestorDepartment) searchCriteria.push('Requestor Department');
      if (data.requestorEmail) searchCriteria.push('Requestor Email Address');
      if (data.requestorFirstName) searchCriteria.push('Requestor First Name');
      if (data.requestorLastName) searchCriteria.push('Requestor Last Name');
    }
    return searchCriteria;
  };

  return (
    <Modal
      autoFocus={false}
      id="globalSearchModal"
      show={show}
      setShow={setShow}
      extraCloseStep={clearFormHandler}
      actionButtons={
        <>
          <SActionButtonsContainer>
            <SButton className="hoverable--dark" color="secondary" onClick={clearFormHandler} id="btnCloseGlobalSearch">
              Close
            </SButton>
            <SButton
              title={searchButtonToolTip}
              className="hoverable--dark"
              onClick={handleGlobalSearchData}
              id="btnExecuteGlobalSearch"
              disabled={isDisableSearch}
            >
              Search
            </SButton>
          </SActionButtonsContainer>
        </>
      }
    >
      <FormProvider {...methods}>
        {' '}
        <SModalBodyContainer>
          <div className="global-search-body">
            <SModalTitle>
              <FontAwesomeIcon icon={faSearch} />
              {title}
            </SModalTitle>
            <Input
              name="keyWord"
              label="Search Value"
              inputType="text"
              maxLength={30}
              className="search-criteria-field"
              tooltipError
              autoFocus={true}
              onBlur={(e) => {
                stripTrailingSpaces(e);
              }}
              extraOnChange={(e: any) => {
                validateKeyWord(e);
              }}
              validations={{
                required: 'Search requires a minimum 3 character Search Value and at least 1 Search Field selected.',
                minLength: {
                  value: 3,
                  message: 'Search requires a minimum 3 character Search Value and at least 1 Search Field selected.',
                },
              }}
            />
            <SLabel id={`lblSearchFields`}>Search Fields</SLabel>
            <SLabelStandAlone id={`lblStandaloneSearchFields`}>Standalone Search Fields</SLabelStandAlone>
            <SModalCheckboxContainter>
              <div className="inner-container">
                <LabeledCheckbox
                  name="location"
                  label="Location Name"
                  isDisabled={disableLocation}
                  isFormControl={true}
                />
                <LabeledCheckbox
                  name="messageTitle"
                  label="Message Title"
                  isDisabled={disableMessageTitle}
                  isFormControl={true}
                />
                <LabeledCheckbox
                  name="messageId"
                  label="Message ID"
                  isDisabled={disableMessageId}
                  isFormControl={true}
                />
                <LabeledCheckbox
                  name="graphicId"
                  label="Graphic ID"
                  isDisabled={disableGraphicId}
                  isFormControl={true}
                />
                <LabeledCheckbox
                  name="creatorUserId"
                  label="Creator User ID"
                  isDisabled={disableCreatorUserId}
                  isFormControl={true}
                />
                <LabeledCheckbox
                  name="approverUserId"
                  label="Approver User ID"
                  isDisabled={disableApproverUserId}
                  isFormControl={true}
                />
              </div>
              <div className="inner-container">
                <LabeledCheckbox
                  name="requestorEmail"
                  label="Requestor Email Address"
                  isDisabled={disableRequestorEmail}
                  isFormControl={true}
                />
                <LabeledCheckbox
                  name="requestorFirstName"
                  label="Requestor First Name"
                  isDisabled={disableRequestorFirstName}
                  isFormControl={true}
                />
                <LabeledCheckbox
                  name="requestorLastName"
                  label="Requestor Last Name"
                  isDisabled={disableRequestorLastName}
                  isFormControl={true}
                />
                <LabeledCheckbox
                  name="requestorDepartment"
                  label="Requestor Department"
                  isDisabled={disableRequestorDepartment}
                  isFormControl={true}
                />
              </div>

              <div className="inner-container">
                <div className="standalone-search-border">
                  <LabeledCheckbox
                    name="messageText"
                    label="Message Text"
                    isDisabled={disableMessageText}
                    isFormControl={true}
                  />
                  <LabeledCheckbox
                    name="selectivityFieldName"
                    label="Selectivity Field Name"
                    isDisabled={disableSelectivityFieldName}
                    isFormControl={true}
                  />
                  <LabeledCheckbox
                    name="selectivityValue"
                    label="Selectivity Value"
                    isDisabled={disableSelectivityValue}
                    isFormControl={true}
                  />
                </div>
              </div>
            </SModalCheckboxContainter>
          </div>
        </SModalBodyContainer>
      </FormProvider>
    </Modal>
  );
};
export default ModalGlobalSearch;
